// Installation « écran d'accueil » (PWA légère, sans compte Apple/Google) pour la carte de membre.
const SW_PATH = "/sw-carte.js";
const SW_SCOPE = "/carte-membre/";

export function isStandalone() {
  return window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;
}

export function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
}

export function isAndroid() {
  return /android/i.test(navigator.userAgent);
}

// Manifeste dynamique : l'icône installée ouvre directement CETTE carte.
export function injectPassManifest(name) {
  document.querySelectorAll("link[data-pass-manifest], meta[data-pass-meta]").forEach((n) => n.remove());
  const origin = window.location.origin;
  const manifest = {
    name: `Carte Impact — ${name || "Membre"}`,
    short_name: "Carte Impact",
    start_url: window.location.href,
    scope: `${origin}${SW_SCOPE}`,
    display: "standalone",
    background_color: "#09090b",
    theme_color: "#09090b",
    icons: [
      { src: `${origin}/kaizen-icon-512.png`, sizes: "512x512", type: "image/png", purpose: "any maskable" },
      { src: `${origin}/kaizen-icon-1024-v2.png`, sizes: "1024x1024", type: "image/png" },
    ],
  };
  const link = document.createElement("link");
  link.rel = "manifest";
  link.setAttribute("data-pass-manifest", "1");
  link.href = `data:application/manifest+json,${encodeURIComponent(JSON.stringify(manifest))}`;
  document.head.appendChild(link);

  const metas = [
    ["apple-mobile-web-app-capable", "yes"],
    ["mobile-web-app-capable", "yes"],
    ["apple-mobile-web-app-status-bar-style", "black-translucent"],
    ["apple-mobile-web-app-title", "Carte Impact"],
  ];
  metas.forEach(([n, c]) => {
    const m = document.createElement("meta");
    m.name = n; m.content = c; m.setAttribute("data-pass-meta", "1");
    document.head.appendChild(m);
  });
}

export function registerPassServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.register(SW_PATH, { scope: SW_SCOPE }).catch(() => {});
}

// Mémorise l'invite d'installation Android (beforeinstallprompt) dès le chargement du module.
let deferredPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferredPrompt = e; });
}
export function hasNativeInstallPrompt() { return !!deferredPrompt; }
export async function triggerNativeInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice.catch(() => null);
  deferredPrompt = null;
  return choice?.outcome === "accepted";
}
